import SelectionInfoIcon from '@resources/icons/SelectionInfoIcon.svg?react';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { ObjectSelection, SelectObjectsCommand, useViewerContext } from '@stereograph/teiaviewer';
import { useEffect, useState } from 'react';
import { IconButton } from '@stereograph/teia-system-design/components/IconButton';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { EyeIcon } from '@heroicons/react/24/outline';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { Text } from '@stereograph/teia-system-design/components/Typography';

interface SelectionBannerProps {
  label: string;
  selection: ObjectSelection | Array<string>;
  onSelectionChange?: (selection: ObjectSelection) => void;
}

export const SelectionBanner = (props: SelectionBannerProps) => {
  const { label, selection, onSelectionChange } = props;
  const { viewer } = useViewerContext();
  const [selectionChanged, setSelectionChanged] = useState(false);

  const onShowSelectionFilter = async () => {
    const command = new SelectObjectsCommand(viewer, selection);
    command.execute();
  };

  const selectionChangedSignalHandler = () => {
    setSelectionChanged(true);
  };

  const selectionChangeHandler = () => {
    if (onSelectionChange) {
      onSelectionChange(viewer.scene.objectSelection);
      setSelectionChanged(false);
    }
  };

  useEffect(() => {
    viewer.signals.onObjectSelectionChanged.connect(selectionChangedSignalHandler);

    return () => {
      viewer.signals.onObjectSelectionChanged.disconnect(selectionChangedSignalHandler);
    };
  }, [viewer.signals.onObjectSelectionChanged]);

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.primary.light,
        px: 3,
        py: 2.5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Text variant="body2" bold>{label}</Text>
      <Stack direction="row">
        {!!selectionChanged && !!onSelectionChange && (
          <IconButton
            aria-label="change selection"
            iconOnly
            onClick={selectionChangeHandler}
          >
            <Icon component={SelectionInfoIcon}></Icon>
          </IconButton>
        )}
        <IconButton
          aria-label="show selection"
          iconOnly
          onClick={onShowSelectionFilter}
        >
          <Icon component={EyeIcon}></Icon>
        </IconButton>
      </Stack>
    </Box>
  );
};
